import { render, staticRenderFns } from "./EditSetupPreview.vue?vue&type=template&id=52d49a70&"
import script from "./EditSetupPreview.vue?vue&type=script&lang=js&"
export * from "./EditSetupPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports